/// <reference path="../../../../Frontend.Core/dist/definitions/NCB.d.ts" />
/// <reference path="../../../../Frontend.Core/dist/definitions/NCB.DateUtils.d.ts" />
/// <reference path="../../../../Frontend.Core/dist/definitions/NCB.Calendar.d.ts" />
/// <reference path="../../../../Frontend.Core/dist/definitions/NCB.I18n.d.ts" />

import * as React from "react";
import {toJS} from 'mobx';
import {observer} from 'mobx-react';
import {GuestSelector} from "./guestSelector";
import appstate, { IAppMode } from "../../appstate";
import {DatepickerDay} from "./datepickerDay";
import {DatepickerWidget} from "./datepickerWidget";
import {PriceCalendar} from "./priceCalendar";
import {PromotionBar}from "../shared/promotionBar";
import {LoadingPage} from "../shared/loadingPage";
import {Modal} from "../shared/modal";

import calendarStore from "../../stores/calendarStore";
import {CurrencyConverter} from "../shared/currencyConverter";

import "./datepicker.scss";
import { AffiliateHotels } from "../wizard/affiliateHotels";

export interface IDatepickerProps {    
    onSetCalendar: (startDate: Date, endDate: Date, showCalendar?: boolean, promotionCode?: string, rooms?: CC.Library.Models.Calendar.NcbCalendarRoom[], groupCode?: string)  => void,
    startDate: Date,
    endDate: Date
    guestCount: CC.Library.Models.Calendar.NcbCalendarRoom[],
    promotionCode: string,
    ratePlanOrGroupCode: string,
    roomTypeCodeFilter: string,
    limitGuestSelection: boolean,
    showPriceCalendar?: boolean,
    showTotalPrice?: boolean,
    hidePromotionCode: boolean,
    hideEndDate?: boolean,
    showCampaignCodeInline?:boolean,
    showStartDateWidget?: boolean,
    showEndDateWidget?: boolean,
    isModalOpen?: boolean,
    isGuestSelectorOpen?: boolean
}

export interface IDatepickerState {
    startDate: Date,
    endDate: Date,
    showStartDateWidget: boolean,
    showEndDateWidget: boolean,
    guestCount: CC.Library.Models.Calendar.NcbCalendarRoom[],
    promotionCode: string,
    ratePlanOrGroupCode: string,
    isPromotionCodeToggled: boolean,
    startMonthIndex: number,
    endMonthIndex: number,
    showPriceCalendar: boolean,
    showError: boolean,
    errorMessage: string,
    isSubmitEnabled: boolean,
    isModalOpen: boolean,
    tick: number,
    isLoading: boolean,
    showDateChangeWarning: JSX.Element, // NCB-713
    userToggledDate: boolean, // NHRSUPPORT-233
    isPeriodAvailable: boolean,
    isAlternativeHotelModalOpen: boolean,
    blockWidget: boolean
}

@observer
export class Datepicker extends React.Component<IDatepickerProps, IDatepickerState> {

    periodTimer: number;
    currentYear: number;

    constructor(props: IDatepickerProps) {
        super(props);

        this.props = props;

        this.handleSubmit = this.handleSubmit.bind(this);
        this.setStartDate = this.setStartDate.bind(this);
        this.setEndDate = this.setEndDate.bind(this);
        this.handleBodyEvent = this.handleBodyEvent.bind(this);
        this.findEndDate = this.findEndDate.bind(this);
        this.setGuests = this.setGuests.bind(this);
        this.handleBookingCodeSubmit = this.handleBookingCodeSubmit.bind(this);
        this.handlePromotionCodeChange = this.handlePromotionCodeChange.bind(this);
        this.toggleStartWidget = this.toggleStartWidget.bind(this);
        this.toggleEndWidget = this.toggleEndWidget.bind(this);
        this.setDates = this.setDates.bind(this);
        this.renderFooterBar = this.renderFooterBar.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.getTotalPrice = this.getTotalPrice.bind(this);

        let initialStartDate = props.startDate ? new Date(props.startDate.getTime()) : null;
        let initialEndDate = props.endDate ? new Date(props.endDate.getTime()) : null;

        this.currentYear = new Date().getUTCFullYear();

        this.state = {
            startDate: initialStartDate,
            endDate: initialEndDate,
            guestCount: props.guestCount,
            showStartDateWidget: this.props.showStartDateWidget === true,
            showEndDateWidget: this.props.showEndDateWidget === true,
            promotionCode: props.promotionCode,
            ratePlanOrGroupCode: props.ratePlanOrGroupCode,
            isPromotionCodeToggled: false,
            startMonthIndex: this.findMonthIndex(initialStartDate),
            endMonthIndex: this.findMonthIndex(initialEndDate),
            showPriceCalendar: this.props.showPriceCalendar || false,
            showError: false,
            errorMessage: "",
            isSubmitEnabled: true,
            isModalOpen: this.props.isModalOpen === true,
            tick: 0,
            isLoading: false,
            showDateChangeWarning: null,
            userToggledDate: false,
            isPeriodAvailable: true,
            isAlternativeHotelModalOpen: false,
            blockWidget: true
        };

        if (initialStartDate != null)
            calendarStore.hintStartDate = initialStartDate;

        calendarStore.loadCalendar(NCB.Settings.ForceStartYear || null, NCB.Settings.ForceStartMonth || null, props.guestCount, props.promotionCode, props.ratePlanOrGroupCode, this.calendarLoadCallback, this.props.roomTypeCodeFilter, () => {this.refresh()});
    }
    

    componentWillReceiveProps(nextProps: IDatepickerProps) {

        if ("" + this.props.startDate + this.props.endDate + JSON.stringify(this.props.guestCount) + this.props.promotionCode + this.props.ratePlanOrGroupCode
            === "" + nextProps.startDate + nextProps.endDate + JSON.stringify(nextProps.guestCount) + nextProps.promotionCode + nextProps.ratePlanOrGroupCode) {
                return;
            }
        
        let newState: IDatepickerState = {
            guestCount: nextProps.guestCount,
            promotionCode: nextProps.promotionCode,
            ratePlanOrGroupCode: nextProps.ratePlanOrGroupCode,
            isLoading: true,
            tick: this.state.tick + 1
        } as any;

        if (this.props.startDate == null && nextProps.startDate != null)
            newState.startDate = nextProps.startDate;
        
        if (this.props.endDate == null && nextProps.endDate != null)
            newState.endDate = nextProps.endDate;


        this.setState( newState );
        
        calendarStore.loadCalendar(NCB.Settings.ForceStartYear || null, NCB.Settings.ForceStartMonth || null,nextProps.guestCount, nextProps.promotionCode, nextProps.ratePlanOrGroupCode, this.calendarLoadCallback, this.props.roomTypeCodeFilter, this.refresh);
    }

    componentDidUpdate (prevProps: IDatepickerProps, prevState : IDatepickerState, snapshot: any) {
        if (prevState.showEndDateWidget !== this.state.showEndDateWidget || prevState.showStartDateWidget !== this.state.showStartDateWidget) {
            // Update the body tag
            if (this.state.showStartDateWidget || this.state.showEndDateWidget) {
                document.body.classList.add("ncb-datepicker-is-toggled");
            } else {
                document.body.classList.remove("ncb-datepicker-is-toggled");
            }
        }
    }

    componentWillUnmount() {
        // document.getElementById("NCB-app").removeEventListener("click", this.handleBodyEvent);

        document.body.classList.remove("ncb-datepicker-is-toggled");
        calendarStore.abortAllRequests();

        if (this.periodTimer != null)
            window.clearTimeout(this.periodTimer);
    }

    refresh = () => {
        this.forceUpdate();
    }

    findMonthIndex = (date: Date): number => {
        if (date == null || calendarStore.calendarResponse == null || calendarStore.calendarResponse.Availability == null) {
            console.log("findMonthIndex", "calendarStore.calendarResponse.Availability is null");
            return 0;
        }

        let index = 0;
        let isoDate = NCB.DateUtils.getISODate(date);
        let indexMonth: string = null;

        for (let i=0; calendarStore.calendarResponse.Availability.length > i; i++) {
            let x = calendarStore.calendarResponse.Availability[i];

            if (x != null && x.Date != null) {

                let s = x.Date.split('-');
                if (indexMonth == null) {
                    indexMonth = s[1];
                } else {
                    if (s[1] !== indexMonth) {
                        index++;
                        indexMonth = s[1];
                    }
                }

                if (isoDate === x.Date) {
                    // console.log("findMonthIndex", isoDate, index, toJS(calendarStore.calendarResponse.Availability));
                    return index;
                }
                    
            }
        }

        // console.log("findMonthIndex", isoDate, 0, toJS(calendarStore.calendarResponse.Availability));

        // No match, return index zero
        return 0;

        /*
        let index = 0;

        let today:Date;
        
        if (NCB.Settings.ForceStartMonth != null && NCB.Settings.ForceStartYear != null) {
            today = new Date(NCB.Settings.ForceStartYear, NCB.Settings.ForceStartMonth, 1);
        } else {
            today = new Date();
        }
    
        let targetMonth = today.getUTCMonth();
        let targetYear = today.getUTCFullYear();

        while (index < 64) {
            
            if (date.getUTCMonth() === targetMonth && date.getUTCFullYear() === targetYear)
                return index;

            targetMonth++;

            if (targetMonth > 11) {
                targetYear++;
                targetMonth = 0;
            }

            index++;
        }

        return 0;
        */
    }

    calendarLoadCallback = () => {

        // Preselect the first available period if this is the first time we are receiving a calendar
        if (calendarStore.isPromotionCodeValid && calendarStore.promotionCode != null && calendarStore.promotionCode.length > 0) {
            appstate.promotionCode = calendarStore.promotionCode;
            
            appstate.reservations.forEach((r) => {
                r.Rooms[0].PromotionCode = "" + calendarStore.promotionCode;  
            });
            
            this.setState({
                isModalOpen: false
            });
        } else if (calendarStore.isGroupCodeValid && calendarStore.ratePlanOrGroupCode != null && calendarStore.ratePlanOrGroupCode.length > 0) {
            appstate.ratePlanOrGroupCode = calendarStore.ratePlanOrGroupCode;
            
            this.setState({
                isModalOpen: false
            });
        } else if (this.state.isModalOpen) {
            // We have entered an invalid promotion code

            this.setState({
                promotionCode: ""
            });
        }

        if (this.state.startDate == null || this.state.endDate == null) {
            this.setState({
                blockWidget: false
            });
            
            let firstPeriod = NCB.Calendar.findFirstPeriod(calendarStore.calendarResponse);
            if (firstPeriod != null && firstPeriod.StartDate != null && firstPeriod.EndDate != null) {
                this.props.onSetCalendar(new Date(Date.parse(firstPeriod.StartDate)), new Date(Date.parse(firstPeriod.EndDate)), true);

                this.setState({isSubmitEnabled: true});

            } else {
                alert("Could not find a valid period");

                this.setState({isSubmitEnabled: false});

                NCB.Log.error(new Error("CustomError"), "Could not find a valid period", {
                    startMonth: calendarStore.calendarResponse.StartMonth, 
                    startYear: calendarStore.calendarResponse.StartYear, 
                    numMonths: calendarStore.calendarResponse.NumMonths, 
                    success: calendarStore.calendarResponse.Success});
            }
        } else {

            let isoStartDate = NCB.DateUtils.getISODate(this.state.startDate);
            let isoEndDate = NCB.DateUtils.getISODate(this.state.endDate);

            // Check if the period is loaded before checking if it is valid
            if (!NCB.Calendar.isPeriodLoaded(calendarStore.calendarResponse, isoStartDate, isoEndDate)) {
                console.log("datepicker: Waiting for period " + isoStartDate + "-" + isoEndDate);
                this.periodTimer = window.setTimeout(this.calendarLoadCallback, 500);
                return;
            } else {
                console.log("datepicker: FOUND period " + isoStartDate + "-" + isoEndDate);
                this.setState({
                    blockWidget: false
                });
            }

            // Is the date selected by the user still valid?
            if (NCB.Calendar.isPeriodValid( calendarStore.calendarResponse, 
                                            isoStartDate, 
                                            isoEndDate)) {
                // The selected start/end date is available
                this.setState({
                    isSubmitEnabled: true, 
                    isPeriodAvailable: true,
                    startMonthIndex: this.findMonthIndex(this.state.startDate),
                    endMonthIndex: this.findMonthIndex(this.state.endDate)
                });

            } else {   
                
                // Check if the old start date exists in the new calendar result
                let isDateLoaded = calendarStore.isDateLoaded(NCB.DateUtils.getISODate(this.props.startDate));
                if (!isDateLoaded) {
                    // Check if the calendar is even loaded
                    if (!calendarStore.isFirstPeriodLoaded()) {
                        this.setState({isSubmitEnabled: false, isPeriodAvailable: false});
                        
                        // Wait for the next event to enable the submit state
                        window.setTimeout(this.calendarLoadCallback, 200);

                        return;
                    }
                } else {
                    this.setState({isPeriodAvailable: true});
                }

                let firstPeriod = NCB.Calendar.findFirstPeriod(calendarStore.calendarResponse);
                let newStartDate = new Date(Date.parse(firstPeriod.StartDate));
                let newEndDate = new Date(Date.parse(firstPeriod.EndDate));
                this.props.onSetCalendar(newStartDate, newEndDate, true);
                this.setState({isSubmitEnabled: true});

                // NCB-713
                this.setState({
                    showDateChangeWarning: appstate.useAlternativeHotel ? null : <span>{NCB.I18n.T.DATE_CHANGE_WARNING} <span className="ncb-datepicker-date-warning-date">{firstPeriod.StartDate} – {firstPeriod.EndDate}</span></span>,
                    startDate: newStartDate,
                    endDate: newEndDate,
                    startMonthIndex: this.findMonthIndex(newStartDate),
                    endMonthIndex: this.findMonthIndex(newEndDate)
                });

                

                NCB.Log.metric("Date Change Warning", 1);
            }
        }

        this.setState({
            isLoading: false,
            tick: this.state.tick + 1
        });
       
        this.forceUpdate();
    }

    handlePromotionCodeChange(e: any) {
        this.setState({
            promotionCode: e.currentTarget.value
        });
    }

    handleGroupCodeChange = (e: any) => {
        this.setState({
            ratePlanOrGroupCode: e.currentTarget.value
        });
    }

    handleBookingCodeSubmit() {
        this.setState({
            isLoading: true
        });
        
        calendarStore.loadCalendar(NCB.Settings.ForceStartYear || null, NCB.Settings.ForceStartMonth || null,this.state.guestCount, this.state.promotionCode, this.state.ratePlanOrGroupCode, this.calendarLoadCallback, this.props.roomTypeCodeFilter, this.refresh);

        NCB.Log.metric("Submit Booking Code", 1);
    }

    setGuests(rooms: CC.Library.Models.Calendar.NcbCalendarRoom[]) {
        this.setState({
            guestCount: rooms,
            tick: this.state.tick + 1
        });

        calendarStore.loadCalendar(NCB.Settings.ForceStartYear || null, NCB.Settings.ForceStartMonth || null, rooms, this.props.promotionCode, this.state.ratePlanOrGroupCode, this.calendarLoadCallback, this.props.roomTypeCodeFilter, this.refresh);
    }

    handleSubmit() {
        if (appstate.useAlternativeHotel) {
            if (calendarStore.isDateBookable(this.state.startDate, this.state.endDate) === false) {
                this.setState({
                    isAlternativeHotelModalOpen: true
                });

                return;
            }
        }

        this.props.onSetCalendar(this.state.startDate, this.state.endDate, false, (calendarStore.isPromotionCodeValid ? this.state.promotionCode : ""), this.state.guestCount, (calendarStore.isGroupCodeValid ? this.state.ratePlanOrGroupCode : ""));
    }

    setStartDate(newDate: Date, monthIndex: number) {

        let newEndDate = this.findEndDate(newDate);

        let newEndMonthIndex = monthIndex;
        if (newEndDate.getMonth() > newDate.getMonth() || newEndDate.getFullYear() > newDate.getFullYear())
            newEndMonthIndex++;

        calendarStore.hintStartDate = newDate;

        this.setState({
            startDate: newDate,
            endDate: newEndDate,
            showStartDateWidget: false,
            tick: this.state.tick + 1,
            startMonthIndex: monthIndex,
            endMonthIndex: newEndMonthIndex
        });
    }

    setEndDate(newDate: Date, monthIndex: number ) {
        this.setState({
            endDate: newDate,
            showEndDateWidget: false,
            tick: this.state.tick + 1,
            endMonthIndex: monthIndex
        });
    }

    setDates(newStartDate: Date, newEndDate: Date, monthIndex: number) {
        let newEndMonthIndex = monthIndex;

        if (newEndDate.getMonth() > newStartDate.getMonth() || newEndDate.getFullYear() > newStartDate.getFullYear()) {
            if (newStartDate.getDate() > newEndDate.getDate())
                monthIndex--;
            else
                newEndMonthIndex++;
        }
        
        this.setState({
            startDate: newStartDate,
            endDate: newEndDate,
            showEndDateWidget: false,
            showStartDateWidget: false,
            tick: this.state.tick + 1,
            startMonthIndex: monthIndex,
            endMonthIndex: newEndMonthIndex
        });
    }

    handleBodyEvent(e: any) {
        if (this.state.showStartDateWidget) {
            this.setState({
                showStartDateWidget: false
            });
        } else if (this.state.showEndDateWidget) {
            this.setState({
                showEndDateWidget: false
            });
        }
    }

    findEndDate(startDate: Date): Date {
        // We myst always select a new endDate when the startDate is changed
        let startIsoDate = NCB.DateUtils.getISODate(startDate);

        let foundStartDate = false;
        let minStayOffset = 0;

        for (let i=0; calendarStore.calendarResponse.Availability.length > i; i++) {
            if (foundStartDate) {
                if (minStayOffset > 0) {
                    minStayOffset--;
                } else {
                    return new Date(Date.parse(calendarStore.calendarResponse.Availability[i].Date));
                }

            } else {
                if (calendarStore.calendarResponse.Availability[i].Date === startIsoDate) {
                    foundStartDate = true;
                    
                    // MinStay required?
                    if (calendarStore.calendarResponse.Availability[i].Status === CC.Library.Models.Calendar.AvailabilityStatus.MinStay) {
                        minStayOffset = parseInt(calendarStore.calendarResponse.Availability[i].Quantity) - 1;
                    }
                }
            }
        }

        return null;
    }

    toggleStartWidget(mode: boolean = true) {
        if (mode) {
            this.setState({
                showStartDateWidget: true,
                showEndDateWidget: false,
                userToggledDate: true
            });  
        } else {
            this.setState({
                showStartDateWidget: false
            });
        }
    }

    toggleEndWidget(mode: boolean = true) {
        if (mode) {
            this.setState({
                showEndDateWidget: true,
                showStartDateWidget: false,
                userToggledDate: true
            });  
        } else {
            this.setState({
                showEndDateWidget: false
            });
        }        
    }

    toggleModal() {
        this.setState({
            isModalOpen: !this.state.isModalOpen
        });
    }

    getTotalPrice(): number {
        if (this.state.startDate == null || this.state.endDate == null)
            return null;

        let numNights = NCB.DateUtils.getNumNights(this.state.startDate, this.state.endDate);

        let period = calendarStore.getCalendarPeriod(numNights);
        if (period == null)
            return null;

        let isoStartDate = NCB.DateUtils.getISODate(this.state.startDate);

        let dayCandidate: CC.Library.Models.Calendar.CalendarDay = null;
        period.calendarResponse.forEach(a => {
            let d = a.Availability.filter(x => x.Date === isoStartDate);
            if (d.length > 0)
                dayCandidate = d[0];
        });

        if (dayCandidate != null)
            return parseFloat(dayCandidate.AmountAfterTax);
        
        return null;
    }

    getBookingCodeCancelURL = () => {
    
        let numAdults = NCB.Settings.HotelProperties.DefaultNumberOfAdults; // TODO: Get this value from the GuestCount property instead

        return  NCB.Settings.BookingStartURL + 
                "?startDate=" + NCB.DateUtils.getISODate(this.props.startDate) + 
                "&endDate=" + NCB.DateUtils.getISODate(this.props.endDate) + 
                "&room=" + numAdults + "_0" + 
                "&source=bookingCodeCancel";
    }

    togglePriceCalendar = (e: any) => {
        calendarStore.hintStartDate = this.state.startDate;
        this.setState({showPriceCalendar: !this.state.showPriceCalendar});
    }

    renderFooterBar() {

        if (this.props.hidePromotionCode)
            return null;

        let warnings: JSX.Element = null;
        if (!calendarStore.isPromotionCodeValid || !calendarStore.isGroupCodeValid) {
            warnings = <div className="ncb-modal-warning">{NCB.I18n.T.PROMOTION_CODE_IS_NOT_VALID}</div>
        }

        let additionalFooterLinks: JSX.Element[] = null;
        if (NCB.Settings.CalendarFooterLinks != null && NCB.Settings.CalendarFooterLinks.length > 0)
            additionalFooterLinks = NCB.Settings.CalendarFooterLinks.map((x) => {
                return <a href={x.URL} target="_BLANK" className="ncb-page-calendar-additional-footer-link">{x.Label}</a>;
            });

        // Only allow the user to use group or promotion code, not both
        let enablePromotionCodeInput = this.state.ratePlanOrGroupCode == null || this.state.ratePlanOrGroupCode.length < 1;
        let enableGroupCodeInput = this.state.promotionCode == null || this.state.promotionCode.length < 1;

        let bookingCode = (this.props.promotionCode != null && this.props.promotionCode.length > 0) ? this.props.promotionCode : this.props.ratePlanOrGroupCode;

        return <div>
                    <div className="ncb-page-calendar-campaignCode" data-is-toggled={this.state.isPromotionCodeToggled} data-num-rooms={appstate.reservations.length}>
                        <div className="ncb-page-calendar-campaignCode-inner">

                            {(appstate.isNonRoom ? null : <span className="ncb-page-calendar-pricecalendar-toggle" onClick={this.togglePriceCalendar}>{(this.state.showPriceCalendar ? NCB.I18n.T.SHOW_DATEPICKER : NCB.I18n.T.SHOW_PRICECALENDAR)}</span>)}
                            
                            {(this.props.showCampaignCodeInline === true || (appstate.modifyConfirmationNumber != null && appstate.modifyConfirmationNumber.length > 0)) ? null : <span className="ncb-page-calendar-campaignCode-toggle" onClick={() => this.toggleModal()}>{NCB.I18n.T.GOT_BOOKING_CODE_BUTTON}</span>}

                            {additionalFooterLinks}

                            <Modal show={this.state.isModalOpen} onClose={this.toggleModal} passthrough={this.props.showCampaignCodeInline === true && (bookingCode == null || bookingCode.length < 1)}>
                                <div className="ncb-modal-bookingCode-promotionCode-wrapper" data-is-enabled={enablePromotionCodeInput}>
                                    <span className="ncb-modal-header">{NCB.I18n.T.MODAL_HEADLINE_BOOKING_CODE}</span>
                                    <input placeholder={this.props.showCampaignCodeInline === true ? NCB.I18n.T.MODAL_HEADLINE_BOOKING_CODE : ""} className="ncb-modal-bookingCode-input" type="text" name="campaignCode" value={this.state.promotionCode} onChange={this.handlePromotionCodeChange} disabled={!enablePromotionCodeInput} />
                                    <button data-is-loading={this.state.isLoading} 
                                        className="ncb-modal-bookingCode-submit ncb-primary-button" 
                                        onClick={this.handleBookingCodeSubmit} 
                                        disabled={!enablePromotionCodeInput || (this.props.promotionCode != null && this.props.promotionCode.length === 0 && this.state.promotionCode.length === 0)}>
                                        <span>
                                            {NCB.I18n.T.SUBMIT_BOOKING_CODE}
                                        </span>
                                    </button>
                                </div>

                                <div className="ncb-modal-bookingCode-groupCode-wrapper" data-is-enabled={enableGroupCodeInput}>
                                    <span className="ncb-modal-header">{NCB.I18n.T.MODAL_HEADLINE_GROUP_CODE}</span>
                                    <input placeholder={this.props.showCampaignCodeInline === true ? NCB.I18n.T.MODAL_HEADLINE_GROUP_CODE : ""}  className="ncb-modal-bookingCode-input ncb-modal-groupCode-input" type="text" name="groupCode" value={this.state.ratePlanOrGroupCode} onChange={this.handleGroupCodeChange}  disabled={!enableGroupCodeInput} />
                                    <button data-is-loading={this.state.isLoading} 
                                        className="ncb-modal-bookingCode-submit ncb-primary-button" 
                                        onClick={this.handleBookingCodeSubmit} 
                                        disabled={!enableGroupCodeInput || (this.props.ratePlanOrGroupCode != null && this.props.ratePlanOrGroupCode.length === 0 && this.state.ratePlanOrGroupCode.length === 0)}>
                                        <span>
                                            {NCB.I18n.T.SUBMIT_BOOKING_CODE}
                                        </span>
                                    </button>
                                </div>

                                {warnings}

                                <p className="ncb-modal-note">
                                    <strong>{NCB.I18n.T.MODAL_NOTE_HEADLINE_BOOKING}</strong>
                                    {NCB.I18n.T.MODAL_NOTE_BODY_BOOKING}
                                </p>
                            </Modal>
                            
                            <PromotionBar code={bookingCode} onDisableCode={() => { document.location.href = this.getBookingCodeCancelURL() }} />

                        </div>
                    </div>

                </div>;
    }

    renderPeriodInformation = (): JSX.Element => {

        if (this.state.startDate == null || this.state.endDate == null)
            return null;

        let periodInfo = NCB.HotelInformation.getPeriodInfo(NCB.DateUtils.getISODate(this.state.startDate), NCB.DateUtils.getISODate(this.state.endDate));
        if (periodInfo != null && periodInfo.length > 0) {
            return <div className="ncb-period-information">{ periodInfo.map(pi => <div className="ncb-period-information-item">{pi}</div>) }</div>
        }

        return null;
    }

    handleSelectFirstAvailableDate = (startDate: string) => {
        if (startDate != null) {
            let parsedDate = new Date(Date.parse(startDate));
            this.setStartDate(parsedDate, this.findMonthIndex(parsedDate));
        }

        this.setState({
            isAlternativeHotelModalOpen: false
        });
    }
    
    render() {
        if (this.state.showError) {
            return <div className="ncb-errorItem"><b>{NCB.I18n.T.CONNECTION_TO_CRS_LOST}</b><div>{this.state.errorMessage}</div></div>
        }

        // appstate.appMode != IAppMode.Widget && 
        if (calendarStore.calendarResponse == null) {

            window.setTimeout(() => { this.forceUpdate(); }, 50);

            if (appstate.appMode == IAppMode.Widget) {
                // NHRSUPPORT-3811 Return a static datepicker until the calendarResponse is loaded 
                return <div className="ncb-datepicker" 
                            data-is-loading={true} 
                            onClick={(e: any) => {e.stopPropagation(); }} 
                            data-is-toggled={this.state.showStartDateWidget || this.state.showEndDateWidget} 
                            data-num-rooms={appstate.reservations.length} 
                            data-show-date-warning={this.state.showDateChangeWarning != null}>
                            <div className="ncb-datepicker-inner">

                                <div className="ncb-datepicker-day-wrapper" style={{position: "relative", zIndex: 999}}>
                                    <div className="ncb-datepicker-day" data-is-toggled="false">
                                        <span className="ncb-datepicker-day-label">{NCB.I18n.T.CHECK_IN}</span>
                                        <div className="ncb-datepicker-day-content">
                                            <span className="ncb-datepicker-day-weekday">&nbsp;</span>
                                            <span className="ncb-datepicker-day-date">&nbsp;</span>
                                            <span className="ncb-datepicker-day-month">&nbsp;</span>
                                        </div>
                                        <div className="ncb-datepicker-day-simple-date" style={{display: "none"}}>{ (this.state.startDate == null ? "..." : NCB.DateUtils.getISODate(this.state.startDate)) }</div>
                                    </div>
                                    <div className="ncb-datepicker-day" data-is-toggled="false">
                                        <span className="ncb-datepicker-day-label">{NCB.I18n.T.CHECK_OUT}</span>
                                        <div className="ncb-datepicker-day-content">
                                            <span className="ncb-datepicker-day-weekday">&nbsp;</span>
                                            <span className="ncb-datepicker-day-date">&nbsp;</span>
                                            <span className="ncb-datepicker-day-month">&nbsp;</span>
                                        </div>
                                        <div className="ncb-datepicker-day-simple-date" style={{display: "none"}}>{ (this.state.endDate == null ? "..." : NCB.DateUtils.getISODate(this.state.endDate)) }</div>
                                    </div>
                                </div>

                                <GuestSelector  forceSimpleGuestSelector={true} 
                                                onSubmit={this.handleSubmit} 
                                                isSubmitEnbled={false} 
                                                forceHide={false} 
                                                guestCount={this.state.guestCount} 
                                                limitGuestSelection={this.props.limitGuestSelection} 
                                                changeCallback={this.setGuests} />;

                                <div className="ncb-datepicker-submitWrapper">
                                    <button id="ncb-datepicker-submitWrapper-button" onClick={this.handleSubmit} disabled={true}>
                                        <span>
                                            {(appstate.isNonRoom ? NCB.I18n.T.CONTINUE : NCB.I18n.T.VIEW_ROOM_AND_PRICES)}
                                        </span>
                                    </button>
                                </div>
                            </div>
                            {this.renderFooterBar()}
                            
                        </div>;
            } else {
                return <LoadingPage headline="" message="" isFullPage={appstate.isMobile} />;
            }
        }

        if (!this.state.isPeriodAvailable) {
            return <LoadingPage headline={NCB.I18n.T.PLEASE_WAIT} message={NCB.I18n.T.SEARCHING_FOR_BOOKABLE_DATES} isFullPage={appstate.isMobile} />;
        }
        
        let submitWarning: JSX.Element = null;
        if (this.state.showDateChangeWarning) {
            submitWarning = <div className="ncb-datepicker-date-warning-v2"  onClick={(e: any) => { e.stopPropagation(); this.setState({showDateChangeWarning: null})}}>
                <div className="ncb-datepicker-date-warning-inner">
                    <h3>{NCB.I18n.T.DATE_CHANGE_WARNING_HEADLINE}</h3>
                    <div className="ncb-datepicker-date-warning-text">{this.state.showDateChangeWarning}</div>
                    <div className="ncb-datepicker-date-warning-dismiss">
                        <span>{NCB.I18n.T.CLOSE}</span>
                    </div>
                </div>
            </div>;
        }

        if (this.state.showPriceCalendar) {
            if (calendarStore.calendarResponse == null || calendarStore.calendarResponse.Availability == null)
                return null;

            let firstSelectableDate = NCB.DateUtils.getToday();
            let isSubmitDisabled = (calendarStore.calendarResponse.Availability == null);

            let guestSelector = <GuestSelector forceSimpleGuestSelector={true} onSubmit={this.handleSubmit} isSubmitEnbled={!isSubmitDisabled} forceHide={false} guestCount={this.state.guestCount} limitGuestSelection={this.props.limitGuestSelection} changeCallback={this.setGuests} />;
        
            // TODO: Get the first/last date from the availability response instead
            let today = new Date();
            let tomorrow = new Date();
            tomorrow.setUTCDate(today.getUTCDate() + 1);

            return <div className="ncb-datepicker" data-is-loading={!calendarStore.foundFirstAvailablePeriod} onClick={(e: any) => {e.stopPropagation(); }} data-show-date-warning={this.state.showDateChangeWarning != null}>

                <PriceCalendar  selectedStartDate={(this.state.startDate || today)} 
                                selectedEndDate={(this.state.endDate || tomorrow)} 
                                setDatesDateCallback={this.setDates}
                                firstSelectableDate={firstSelectableDate} 
                                startMonthIndex={this.state.startMonthIndex}
                                promotionCode={this.props.promotionCode}>{guestSelector}</PriceCalendar>
                
                {this.renderPeriodInformation()}

                <div className="ncb-datepicker-submitWrapper">
                    <button id="ncb-datepicker-submitWrapper-button" onClick={this.handleSubmit} disabled={isSubmitDisabled}>
                        <div className="subtitle subtitle-with-price">
                            <CurrencyConverter currency={appstate.currency} price={this.getTotalPrice()} prefix={NCB.I18n.T.TOTAL + " "} />
                            {NCB.I18n.T.CUSTOMIZE_YOUR_ROOM}
                        </div>
                    </button>
                </div>

                {submitWarning}
    
                {this.renderFooterBar()}
    
            </div>;
        } else {

        let startDateWidget: JSX.Element =  null;
        if (this.state.showStartDateWidget) {
            let firstSelectableDate = NCB.DateUtils.getToday();
            startDateWidget = <DatepickerWidget currentStartdate={this.state.startDate}
                                                currentEndDate={this.state.endDate}
                                                isStartDate={true} 
                                                availabilityCalendar={calendarStore.calendarResponse} 
                                                selectedDate={this.state.startDate} 
                                                setDateCallback={this.setStartDate} 
                                                firstSelectableDate={firstSelectableDate} 
                                                headline="Select arrival date" 
                                                toggleCallback={this.toggleStartWidget} 
                                                startMonthIndex={this.state.startMonthIndex} />;
        }
        
        let endDateWidget: JSX.Element = null;
        if (this.state.showEndDateWidget) {
            let firstSelectableDate = new Date(this.state.startDate.getTime());

            firstSelectableDate.setUTCDate(this.state.startDate.getUTCDate() + 1);

            endDateWidget = <DatepickerWidget currentStartdate={this.state.startDate}
                                              currentEndDate={this.state.endDate}
                                              isStartDate={false} 
                                              availabilityCalendar={calendarStore.calendarResponse} 
                                              selectedDate={this.state.endDate} 
                                              setDateCallback={this.setEndDate} 
                                              firstSelectableDate={firstSelectableDate} 
                                              headline="Select departure date" 
                                              toggleCallback={this.toggleEndWidget} 
                                              startMonthIndex={this.state.endMonthIndex} />;
        }
        
        // Min/Maxstay?
        // TODO: Move this block outside of the render method
        let minMaxStayMessage: JSX.Element = null;
        if (this.state.startDate != null) {
            let isoStartDate = NCB.DateUtils.getISODate(this.state.startDate);
            let currentStatDate = calendarStore.calendarResponse.Availability.filter(x => x.Date === isoStartDate);
            if (currentStatDate.length > 0) {
                if (currentStatDate[0].Status === CC.Library.Models.Calendar.AvailabilityStatus.MinStay) {
                    minMaxStayMessage = <div className="ncb-minMaxStayMessage">{NCB.I18n.T.MINIMUM} {currentStatDate[0].Quantity} {NCB.I18n.T.NIGHTS_OF_STAY_FOR_ARRIVAL_ON_THIS_DATE}</div>;
                } else if (currentStatDate[0].Status === CC.Library.Models.Calendar.AvailabilityStatus.MaxStay) {
                    minMaxStayMessage = <div className="ncb-minMaxStayMessage">{NCB.I18n.T.MAXIMUM} {currentStatDate[0].Quantity} {NCB.I18n.T.NIGHTS_OF_STAY_FOR_ARRIVAL_ON_THIS_DATE}</div>;
                } else {
                    minMaxStayMessage = null;
                }
            } 
        }

        let isSubmitDisabled = (calendarStore.calendarResponse == null || !this.state.isSubmitEnabled);
        let guestSelector = <GuestSelector isGuestControlToggled={this.props.isGuestSelectorOpen} forceSimpleGuestSelector={false} onSubmit={this.handleSubmit} isSubmitEnbled={!isSubmitDisabled} forceHide={this.state.showStartDateWidget || this.state.showEndDateWidget} guestCount={this.state.guestCount} limitGuestSelection={this.props.limitGuestSelection} changeCallback={this.setGuests} />;

        let affiliateHotelsModal: JSX.Element = null;
        if (this.state.isAlternativeHotelModalOpen) {

            affiliateHotelsModal = <Modal className={"ncb-affiliate-modal"} show={this.state.isAlternativeHotelModalOpen} onClose={() => this.setState({ isAlternativeHotelModalOpen: false })}>
                    <AffiliateHotels firstAvailableDate={calendarStore.getFirstBookableDate()} 
                                    selectFirstAvailableDateCallback={this.handleSelectFirstAvailableDate} 
                                    startDate={NCB.DateUtils.getISODate(this.state.startDate)} 
                                    endDate={NCB.DateUtils.getISODate(this.state.endDate)} 
                                    guestCount={this.state.guestCount} />
                </Modal>;
        }

        // NHRSUPPORT-1846
        let showYear = !(this.state.startDate != null && this.state.endDate != null && this.state.startDate.getUTCFullYear() === this.currentYear && this.state.endDate.getUTCFullYear() === this.currentYear);

        return <div className="ncb-datepicker" data-is-loading={this.state.blockWidget || !calendarStore.foundFirstAvailablePeriod} onClick={(e: any) => {e.stopPropagation(); }} data-is-toggled={this.state.showStartDateWidget || this.state.showEndDateWidget} data-num-rooms={appstate.reservations.length} data-show-date-warning={this.state.showDateChangeWarning != null}>

                <div className="ncb-datepicker-inner">
                    <div className="ncb-datepicker-day-wrapper" style={{position: "relative", zIndex: 999}}>

                        <DatepickerDay showYear={showYear} isDisabled={this.state.blockWidget} userToggledDate={this.state.userToggledDate} isCheckout={false} label={appstate.isNonRoom ? NCB.I18n.T.ARRIVAL_SLASH_DEPARTURE_DATES : NCB.I18n.T.CHECK_IN} isToggled={this.state.showStartDateWidget} date={this.state.startDate} toggleCallback={this.toggleStartWidget} />

                        {this.props.hideEndDate === true ? null : <DatepickerDay showYear={showYear} isDisabled={this.state.blockWidget} userToggledDate={this.state.userToggledDate} isCheckout={true} label={NCB.I18n.T.CHECK_OUT} isToggled={this.state.showEndDateWidget} date={this.state.endDate} toggleCallback={this.toggleEndWidget} />}

                        {startDateWidget}
                        {endDateWidget}

                    </div>

                    {minMaxStayMessage}

                    {guestSelector}

                    {this.renderPeriodInformation()}

                    <div className="ncb-datepicker-submitWrapper">
                        <button id="ncb-datepicker-submitWrapper-button" onClick={this.handleSubmit} disabled={isSubmitDisabled}>
                            <span>
                                {(appstate.isNonRoom ? NCB.I18n.T.CONTINUE : NCB.I18n.T.VIEW_ROOM_AND_PRICES)}
                            </span>
                        </button>
                    </div>

                    {submitWarning}

                </div>

                {this.renderFooterBar()}

                {
                    affiliateHotelsModal
                }
                
            </div>;
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/datepicker/datepicker.tsx